import React, { useEffect, useState } from 'react';
import NavContainer from './Nav';
import OffCanvasNav from './OffCanvasNav';
import { dotoniwoofApi } from '../api/dotoniwooApi';
import { Card, Col, Container, Form, Row, Table, Button, Modal, Alert } from 'react-bootstrap';
import ItemCard from './ItemCard';
import { useAuth } from '../context/AuthContext';
import IconDelete from '../elements/IconDelete';
import Pagination from './Pagination';
import { Helmet } from 'react-helmet';


const RegisterSale = () => {


    const { user } = useAuth();
    const [items, setItems] = useState([]);
    const [payments, setPayments] = useState([]);
    const [dataResponse, setResponseData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState('');
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showErrorAlertModal, setShowSuccessAlertModal] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerAmount, setCustomerAmount] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 60;

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;


    // Calcular el total de los precios
    const totalPrice = selectedItems.reduce((acc, item) => acc + parseFloat(item.price), 0);

    // Obtener la cantidad de productos seleccionados
    const totalProducts = selectedItems.length;

    // Obtener la fecha actual

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
    const day = String(now.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const [currentDate, setCurrentDate] = useState(formattedDate);


    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(items.length / itemsPerPage);

    const handleAddToCart = (item) => {
        setSelectedItems((prevItems) => [...prevItems, item]);
    };


    useEffect(() => {
        getitems();
        getPayments();
    }, []);


    const getitems = async () => {
        await dotoniwoofApi.get(`/item.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setItems(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };


    const getPayments = async () => {
        await dotoniwoofApi.get(`/paymentMethod.php`)
            .then(res => {
                let responseApi = res.data;
                if (responseApi.code === 200) {
                    setPayments(responseApi.message);
                }

            })
            .catch(err => {
                console.log(err);
            }).finally(
                () => {
                }
            )
    };
    // Función para filtrar los ítems según el término de búsqueda
    const filteredItems = items.filter((item) => {
        return (
            item.product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    });


    const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
    const sortItems = [...currentItems].sort((a, b) => {
        return a.description.localeCompare(b.description);
    });

    const handleConfirmPurchase = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSelectPaymentMethod = (e) => {
        setPaymentMethod(e.target.value);
    };

    const deleteItemSale = (itemID) => {
        setSelectedItems(selectedItems.filter(item => item.id_item !== itemID));
    }

    const handleSubmitPurchase = async () => {

        try {
            const { data } = await dotoniwoofApi.post("/sale.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    date: currentDate,
                    items: selectedItems,
                    total: totalPrice,
                    paymentMethod: paymentMethod,
                }));
            setResponseData(data);
            if (data.code === 201) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
                setSelectedItems([]);
                setPaymentMethod('');
                getitems();
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
        // Aquí puedes hacer un POST para enviar la venta al backend
        handleCloseModal(); // Cerrar el modal después de confirmar
    };

    const handleSubmitPaymentPlan = async () => {


        if (!customerName.trim() || !customerPhone.trim() || !customerAmount.trim()) {
            dataResponse.message = "TODOS LOS CAMPOS SON OBLIGATORIOS";
            setShowSuccessAlertModal(true);
            setTimeout(() => setShowSuccessAlertModal(false), 3000);
          }

        else if (customerAmount > totalPrice) {
            dataResponse.message = "ABONO EXCEDE EL VALOR DE LA COMPRA";
            setShowSuccessAlertModal(true);
            setTimeout(() => setShowSuccessAlertModal(false), 3000);

        } else {
            try {
                const { data } = await dotoniwoofApi.post("/paymentPlan.php",
                    JSON.stringify({
                        firebase_UID: user.uid,
                        create_date: currentDate,
                        name: customerName,
                        phone: customerPhone,
                        amount: totalPrice
                    }));
                setResponseData(data);
                if (data.code === 201) {
                    console.log("llamando a Sale");
                    handleSubmitPurchaseWithInstallment(data.id_payment_plan);
                } else {
                    throw new Error('Failed to save category type');
                }
            } catch (error) {
                setShowErrorAlert(true);
                setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
            }
            handleCloseModal(); // Cerrar el modal después de confirmar
        }

    };

    const handleSubmitPurchaseWithInstallment = async (id_payment_plan) => {
        try {
            const { data } = await dotoniwoofApi.post("/sale.php/installment",
                JSON.stringify({
                    firebase_UID: user.uid,
                    date: currentDate,
                    items: selectedItems,
                    total: totalPrice,
                    paymentMethod: paymentMethod,
                }));
            setResponseData(data);
            if (data.code === 201) {
                console.log("llamando a installment");
                handleSubmitInstallment(id_payment_plan, data.idSaleShop);
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
    };


    const handleSubmitInstallment = async (id_payment_plan, id_sale) => {

        try {
            const { data } = await dotoniwoofApi.post("/installment.php",
                JSON.stringify({
                    firebase_UID: user.uid,
                    create_date: currentDate,
                    amount: customerAmount,
                    id_sale: id_sale,
                    id_payment_plan: id_payment_plan,
                    installment_number: 1,
                    total_sale: totalPrice
                }));
            setResponseData(data);
            if (data.code === 201) {
                console.log("installment creado");
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000); // Ocultar alerta de éxito después de 3 segundos
                setSelectedItems([]);
                setPaymentMethod('');
                setCustomerAmount('');
                setCustomerPhone('');
                setCustomerName('');
                getitems();
            } else {
                throw new Error('Failed to save category type');
            }
        } catch (error) {
            setShowErrorAlert(true);
            setTimeout(() => setShowErrorAlert(false), 3000); // Ocultar alerta de error después de 3 segundos
        }
    };



    const handleCustomerNameChange = (e) => setCustomerName(e.target.value);
    const handleCustomerPhoneChange = (e) => setCustomerPhone(e.target.value);
    const handleCustomerAmountChange = (e) => setCustomerAmount(e.target.value);


    return (
        <>
            <NavContainer></NavContainer>
            <OffCanvasNav></OffCanvasNav>
            <Helmet><title>
                Registro de venta
            </title></Helmet>
            <Container>
                {/* Alerta de confirmación de éxito */}
                {showSuccessAlert && (
                    <Alert variant="success">
                        {dataResponse.message}
                    </Alert>
                )}

                {/* Alerta de error */}
                {showErrorAlert && (
                    <Alert variant="danger">
                        {dataResponse.message}
                    </Alert>
                )}

                <h2 className="my-4">Resumen de venta</h2>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Precio</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {selectedItems.map((item, index) => (
                            <tr key={index}>
                                <td>{item.product.name} | {item.weight.weight_name}  {item.color.color_name !== "N/A" && <>|</>} {item.color.color_name !== "N/A" && item.color.color_name} {item.size.size_name !== "N/A" && <>|</>} {item.size.size_name !== "N/A" && item.size.size_name} </td>
                                <td>

                                    ${item.price.toLocaleString('es-CO', {
                                        style: 'currency',
                                        currency: 'COP'
                                    })}

                                </td>
                                <td className="d-flex justify-content-around">
                                    <Button variant='danger'
                                        className='d-flex justify-content-center align-items-center'
                                        onClick={() => deleteItemSale(item.id_item)}>
                                        <IconDelete></IconDelete>
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>


                <Card>
                    <Card.Body>
                        <Form.Group>
                            <Form.Label>Fecha de Venta:</Form.Label>
                            <Form.Control type="date"
                                value={currentDate}
                                onChange={(e) => setCurrentDate(e.target.value)} />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Cantidad de Productos:</Form.Label>
                            <Form.Control type="text" value={totalProducts} readOnly />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Total a Pagar:</Form.Label>
                            <Form.Control
                                type="text"
                                value={`${totalPrice.toLocaleString('es-CO', {
                                    style: 'currency',
                                    currency: 'COP'
                                })}`}
                                readOnly
                            />
                        </Form.Group>
                        {totalProducts !== 0 &&

                            <Button
                                style={{
                                    width: "100%"
                                }}
                                variant="success" className="mt-3" onClick={handleConfirmPurchase}>
                                Confirmar Venta
                            </Button>}
                    </Card.Body>
                </Card>

                <br></br>

                {/* Buscador */}
                <Form.Group className="mb-3" controlId="search">
                    <Form.Label><strong>Buscar Productos</strong></Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Escriba el nombre del producto"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Form.Group>

                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    paginate={paginate}
                />
                <br></br>

                {/* Mostrar ítems filtrados */}
                <Row>
                    {sortItems.map((item) => (
                        <Col md={3} key={item.id_item}>
                            <ItemCard
                                item={item}
                                onAddToCart={handleAddToCart}
                            />
                        </Col>
                    ))}


                </Row>




                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Seleccionar Medio de Pago</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="payments">
                            <Form.Label>Medio de pago</Form.Label>
                            <Form.Control
                                as="select"
                                value={paymentMethod}
                                onChange={handleSelectPaymentMethod}
                            >
                                <option value="">-- Seleccione el medio de pago--</option>
                                {payments.map((type) => (
                                    <option key={type.id_payment_method} value={type.id_payment_method}>
                                        {type.method_name}
                                    </option>
                                ))}
                            </Form.Control>
                        </Form.Group>

                        {
                            paymentMethod == 5 &&
                            <>
                                <br></br>
                                <Card body>
                                    <Card.Title><h3>Registrar Abono</h3></Card.Title>
                                    <Form>
                                        <Form.Group className="mb-3" controlId="formGroupCustomerName">
                                            <Form.Label>Nombre del cliente</Form.Label>
                                            <Form.Control required type="text" placeholder="Digite el nombre" onChange={handleCustomerNameChange} />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="formGroupCustomerPhone">
                                            <Form.Label>Numero de telefono</Form.Label>
                                            <Form.Control required type="text" placeholder="Digite el telefono" onChange={handleCustomerPhoneChange} />
                                        </Form.Group>
                                        <Form.Group className="mb-3" controlId="formGroupCustomerAmount">
                                            <Form.Label>Valor del abono</Form.Label>
                                            <Form.Control required type="text" placeholder="Digite el abono inicial" onChange={handleCustomerAmountChange} />
                                        </Form.Group>
                                        <Button variant="secondary" onClick={handleCloseModal}>Cancelar</Button>
                                        <Button variant="primary" className="ms-2" onClick={handleSubmitPaymentPlan}>Crear Abono</Button>
                                    </Form>
                                    {showErrorAlertModal && (
                                        <>
                                        <br></br>
                                        <Alert variant="danger">
                                            {dataResponse.message}
                                        </Alert></>
                                    )}
                                </Card>
                            </>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        {paymentMethod != 5 && <>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancelar
                            </Button>

                            <Button variant="primary" onClick={handleSubmitPurchase}>
                                Confirmar Compra
                            </Button>
                        </>
                        }
                    </Modal.Footer>
                </Modal>
            </Container>

        </>
    );
}

export default RegisterSale;